import React from "react";
import { User } from "react-feather";

const UserPanel = () => {
	return (
		<div>
			<div className="sidebar-user text-center">
				<div className="avatar-wrapper">
					<div className="avatar-circle">
						<User size={22} color="#adb5bd" />
					</div>
				</div>
				<h6 className="mt-2 f-14 mb-0">مسؤول النظام</h6>
				<p className="f-12">Admin Area</p>
			</div>
		</div>
	);
};

export default UserPanel;
